import React, { forwardRef, ComponentProps } from 'react';

import theme from '@adsk/alloy-react-theme';

import Icon, { IconWithRender } from './Icon';
import { VIEWBOXES } from '../consts';

const GenericDatasetIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(({ size = 24, ...props }, ref) => {
  const use16px = size <= 16;

  return (
    <Icon
      data-testid="GenericDataset"
      ref={ref}
      size={size}
      viewBox={use16px ? VIEWBOXES._16 : VIEWBOXES._24}
      fill="none"
      {...props}
    >
      {use16px ? (
        <>
          <path
            fill={theme.tokens.colors.background.secondary.value}
            d="M.5 0v16h15V4h-4V0H.5Z"
          />
          <path
            fill={theme.tokens.colors.icon.primary.value}
            d="M11.5 0v4h4l-4-4Z"
          />
          <path
            fill={theme.tokens.colors.icon.secondary.value}
            d="M10.5 1h-9v14h13V5h1v11H.5V0h10v1Z"
          />
          <path
            fill={theme.tokens.colors.icon.secondary.value}
            fillOpacity=".6"
            d="M6.5 6.5C6.5 7.32843 5.82843 8 5 8s-1.5-.67157-1.5-1.5S4.17157 5 5 5s1.5.67157 1.5 1.5ZM12.5 6.5c0 .82843-.6716 1.5-1.5 1.5s-1.5-.67157-1.5-1.5S10.1716 5 11 5s1.5.67157 1.5 1.5ZM9.5 12.5c0 .8284-.67157 1.5-1.5 1.5s-1.5-.6716-1.5-1.5S7.17157 11 8 11s1.5.6716 1.5 1.5Z"
          />
          <path
            fill={theme.tokens.colors.icon.secondary.value}
            d="M8 2c.82843 0 1.5.67157 1.5 1.5 0 .65281-.41782 1.20597-1 1.41211v2.1748c.58234.20606 1 .76016 1 1.41309 0 .17235-.03146.33708-.08496.49121l1.66116 1.32809C11.3309 10.1197 11.6513 10 12 10c.8284 0 1.5.6716 1.5 1.5S12.8284 13 12 13s-1.5-.6716-1.5-1.5c0-.1135.0132-.2238.0371-.3301L8.79004 9.77246C8.56033 9.91538 8.29045 10 8 10c-.29104 0-.56199-.08408-.79199-.22754l-1.7461 1.39744c.02391.1063.03809.2166.03809.3301 0 .8284-.67157 1.5-1.5 1.5s-1.5-.6716-1.5-1.5S3.17157 10 4 10c.34845 0 .66821.12.92285.3193l1.66016-1.32809C6.52964 8.83725 6.5 8.67212 6.5 8.5c0-.65293.41766-1.20703 1-1.41309v-2.1748c-.58218-.20614-1-.7593-1-1.41211C6.5 2.67157 7.17157 2 8 2Zm-4 9c-.27614 0-.5.2239-.5.5s.22386.5.5.5.5-.2239.5-.5-.22386-.5-.5-.5Zm8 0c-.2761 0-.5.2239-.5.5s.2239.5.5.5.5-.2239.5-.5-.2239-.5-.5-.5ZM8 8c-.27614 0-.5.22386-.5.5s.22386.5.5.5.5-.22386.5-.5S8.27614 8 8 8Zm0-5c-.27614 0-.5.22386-.5.5s.22386.5.5.5.5-.22386.5-.5S8.27614 3 8 3Z"
          />
        </>
      ) : (
        <>
          <path
            fill={theme.tokens.colors.background.secondary.value}
            d="M.75 0v24h22.5V6h-6V0H.75Z"
          />
          <path
            fill={theme.tokens.colors.icon.primary.value}
            d="M17.25 0v6h6l-6-6Z"
          />
          <path
            fill={theme.tokens.colors.icon.secondary.value}
            d="M15.75 1.5H2.25v21h19.5v-15h1.5V24H.75V0h15v1.5Z"
          />
          <path
            fill={theme.tokens.colors.icon.secondary.value}
            fillOpacity=".6"
            d="M9.75 9.75C9.75 10.9926 8.74264 12 7.5 12s-2.25-1.0074-2.25-2.25c0-1.24264 1.00736-2.25 2.25-2.25s2.25 1.00736 2.25 2.25ZM18.75 9.75c0 1.2426-1.0074 2.25-2.25 2.25s-2.25-1.0074-2.25-2.25c0-1.24264 1.0074-2.25 2.25-2.25s2.25 1.00736 2.25 2.25ZM14.25 18.75c0 1.2426-1.0074 2.25-2.25 2.25s-2.25-1.0074-2.25-2.25S10.7574 16.5 12 16.5s2.25 1.0074 2.25 2.25Z"
          />
          <path
            fill={theme.tokens.colors.icon.secondary.value}
            d="M12 3c1.2426 0 2.25 1.00736 2.25 2.25 0 .97922-.6267 1.80895-1.5 2.11816v3.26224c.8735.3091 1.5 1.1402 1.5 2.1196 0 .2585-.0472.5056-.1274.7368l2.4917 1.9922C16.9964 15.1796 17.4769 15 18 15c1.2426 0 2.25 1.0074 2.25 2.25S19.2426 19.5 18 19.5s-2.25-1.0074-2.25-2.25c0-.1702.0199-.3357.0557-.4951l-2.6206-2.0962C12.8405 14.8731 12.4357 15 12 15c-.4366 0-.843-.1261-1.188-.3413l-2.61913 2.0962c.03585.1595.05713.3248.05713.4951 0 1.2426-1.00736 2.25-2.25 2.25s-2.25-1.0074-2.25-2.25S4.75736 15 6 15c.52267 0 1.00231.18 1.38428.479l2.49023-1.9922c-.08005-.2309-.12451-.4786-.12451-.7368 0-.9794.6265-1.8105 1.5-2.1196V7.36816c-.8733-.30921-1.5-1.13894-1.5-2.11816C9.75 4.00736 10.7574 3 12 3ZM6 16.5c-.41421 0-.75.3358-.75.75s.33579.75.75.75.75-.3358.75-.75-.33579-.75-.75-.75Zm12 0c-.4142 0-.75.3358-.75.75s.3358.75.75.75.75-.3358.75-.75-.3358-.75-.75-.75ZM12 12c-.4142 0-.75.3358-.75.75s.3358.75.75.75.75-.3358.75-.75S12.4142 12 12 12Zm0-7.5c-.4142 0-.75.33579-.75.75s.3358.75.75.75.75-.33579.75-.75-.3358-.75-.75-.75Z"
          />
        </>
      )}
    </Icon>
  );
}) as IconWithRender;

GenericDatasetIcon.displayName = 'GenericDatasetIcon';
GenericDatasetIcon.renderIcon = (props) => <GenericDatasetIcon {...props} />;
export default GenericDatasetIcon;
